import { render, staticRenderFns } from "./generalinfo.vue?vue&type=template&id=4a4c7a8a&scoped=true"
import script from "./generalinfo.vue?vue&type=script&lang=js"
export * from "./generalinfo.vue?vue&type=script&lang=js"
import style0 from "./generalinfo.vue?vue&type=style&index=0&id=4a4c7a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c7a8a",
  null
  
)

export default component.exports